export const getClassName = (...classNames: Array<string | boolean | undefined | null>) =>
  classNames.filter(Boolean).join(" ");
